import { AdvancedImage } from '@cloudinary/react';
import PropTypes from 'prop-types';
import React from 'react';
import { getCloudinaryImage } from '@/utils/commonFunctions';
import { SkillsCardContainer, SkillsCardContent, SkillsCardItem, SkillsCardTitle, SkillsItemLabel } from './styles';

export default function RenderSkills({ skills, title }) {
  return (
    <SkillsCardContainer className="p-3 w-full">
      <SkillsCardTitle>{title}</SkillsCardTitle>
      <SkillsCardContent>
        {skills.map(({ _id, label, imageId, url }) => (
          <SkillsCardItem key={_id} href={url} target="_blank" rel="noopener noreferrer">
            <AdvancedImage cldImg={getCloudinaryImage(imageId)} className="skills__image" />
            <SkillsItemLabel className="title-font font-medium text-white">{label}</SkillsItemLabel>
          </SkillsCardItem>
        ))}
      </SkillsCardContent>
    </SkillsCardContainer>
  );
}

RenderSkills.propTypes = {
  skills: PropTypes.oneOfType([PropTypes.array]).isRequired,
  title: PropTypes.string.isRequired,
};
